var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDecarbonizatorIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.6665 10.3199V10.3732C34.6665 12.1599 35.8665 13.6532 37.5465 14.1866C45.1465 16.5599 50.6665 23.6266 50.6665 31.9999C50.6665 33.3866 50.5065 34.6932 50.2132 35.9732C49.8398 37.6799 50.5332 39.4399 52.0532 40.3466L52.0798 40.3732C54.3732 41.7066 57.3598 40.5066 57.9732 37.9466C58.4265 36.0266 58.6665 34.0266 58.6665 31.9999C58.6665 19.9999 50.7198 9.81322 39.7865 6.47989C37.2532 5.70655 34.6665 7.65322 34.6665 10.3199ZM29.1732 50.4532C21.1998 49.3066 14.7198 42.8266 13.5465 34.8799C12.1065 25.2799 17.9732 16.8266 26.4265 14.1866C28.1332 13.6799 29.3332 12.1599 29.3332 10.3732V10.3199C29.3332 7.65322 26.7465 5.70655 24.1865 6.47989C12.1598 10.1599 3.75985 22.1066 5.57318 35.7066C7.14652 47.3866 16.5865 56.8266 28.2665 58.3999C36.6398 59.5199 44.3732 56.7732 49.9465 51.6532C51.9198 49.8399 51.5732 46.6132 49.2532 45.2799C47.7065 44.3732 45.7865 44.6666 44.4532 45.8666C40.5332 49.4399 35.0932 51.3332 29.1732 50.4532Z",
    fill: "#2D5AA8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecarbonizatorIcon);
export default __webpack_public_path__ + "static/media/DecarbonizatorIcon.f425f40d6f7d11e63f539f6f582f365b.svg";
export { ForwardRef as ReactComponent };